export default __webpack_public_path__ + "static/media/no_matches_women bg.8f548a4c.webp";